import styled from 'styled-components';
import {
  Segment,
  Text as TextLayoutComponent,
  Button as ButtonLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled(Segment)`
  display: flex;
  padding: 20px;
  flex-direction: column;
  border: 1px solid black;
  width: 900px;
  &.ui.segment {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
`;

export const Title = styled(TextLayoutComponent)`
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 500;
`;

export const Description = styled(TextLayoutComponent)`
  margin: 10px 0;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-left: 20px;
  }
`;

export const ButtonCancel = styled(ButtonLayoutComponent.Inverted)``;
